import styled from 'styled-components'
import AlertTriangleIcon from '../../../icons/IconLib/AlertTriangleIcon'

const ErrorPalletLog = () => (
  <Wrapper role="alert">
    <IconWrapper>
      <AlertTriangleIcon />
    </IconWrapper>
    <Title>שגיאה בטעינת הנתונים</Title>
    <Subtitle>לא ניתן לטעון את לוג המשטחים. אנא נסה שוב מאוחר יותר.</Subtitle>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6em;
  padding: 2.4em 1.5em;
  direction: rtl;
`

const IconWrapper = styled.div`
  width: 3.6em;
  height: 3.6em;
  border-radius: 50%;
  background: #fff2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  color: #e05252;
  margin-bottom: 0.2em;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`

const Title = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: #2d3a4a;
  margin: 0;
`

const Subtitle = styled.p`
  font-size: 0.82rem;
  color: #8a9ab0;
  margin: 0;
  text-align: center;
`

export default ErrorPalletLog
